import { Tune } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const FilterHeader = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        height: '64px',
        [theme.breakpoints.down('sm')]: {
          height: '50px',
        },
      }}
    >
      <Tune />
      <Typography sx={{ fontSize: 16 }}>{t('common.filter.header')}</Typography>
    </Box>
  );
};
